import type { UserAgentUtils } from '@change-corgi/core/userAgent';
import { createUserAgentUtils as _createUserAgentUtils } from '@change-corgi/core/userAgent';
import { getWindow } from '@change-corgi/core/window';

export function createUserAgentUtils(): UserAgentUtils {
	return _createUserAgentUtils({ userAgent: getWindow().navigator.userAgent });
}
